import { channels } from "@/mocks/home";

export default function Channels() {
  return (
    <section id="channels" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            Channels Overview
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            六大资源渠道速览
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            查找「善良的女秘书」时，不同渠道各有用武之地。下面先横向认识六个常见入口，了解它们各自适合谁、通常以什么形式出现，
            再决定把精力放在哪一两个渠道上。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {channels.map((channel, index) => (
            <article
              key={channel.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${channel.icon} text-xl md:text-2xl`}></i>
                </span>
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap">
                  {channel.tag}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">
                <span className="text-accent-600 mr-1.5 text-sm align-middle">{String(index + 1).padStart(2, "0")}</span>
                {channel.name}
              </h3>

              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{channel.summary}</p>

              <ul className="mt-4 space-y-2">
                {channel.highlights.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-secondary-600 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <p className="mt-5 pt-4 border-t border-background-200 text-xs text-foreground-500 leading-relaxed">
                <span className="font-semibold text-foreground-700">适合：</span>
                {channel.bestFor}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}